var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 11V8.7847C17 7.00435 16.0533 5.35829 14.5145 4.46296V4.46296C12.9601 3.55862 11.0399 3.55862 9.48553 4.46296V4.46296C7.94669 5.35829 7 7.00435 7 8.7847V11",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5V16.5",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0757 15.9243C11.5862 16.4347 12.4138 16.4347 12.9243 15.9243C13.4347 15.4138 13.4347 14.5862 12.9243 14.0757C12.4138 13.5653 11.5862 13.5653 11.0757 14.0757C10.5653 14.5862 10.5653 15.4138 11.0757 15.9243Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14C5 12.3431 6.34315 11 8 11H16C17.6569 11 19 12.3431 19 14V17C19 18.6569 17.6569 20 16 20H8C6.34315 20 5 18.6569 5 17V14Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.e629aca8a14d2ee13522f1042567f594.svg";
export { ForwardRef as ReactComponent };